function MoveTool(object, isGroupObject, callback) {
    var _this = this;
    this.object = object;

    var activateEvent = function() {
        var infoBeforeDrag = null;
        var onDraggable = false;

        _this.object.style("cursor", "move");

        _this.object.mousedown(function(e) {
            onDraggable = true;

            switch(true) {
                case this.type === "line":
                    var points = this.array().value;

                    infoBeforeDrag = {
                        cursorX: e.clientX,
                        cursorY: e.clientY,
                        x1: points[0][0],
                        y1: points[0][1],
                        x2: points[1][0],
                        y2: points[1][1]
                    };

                    break;

                default:
                    var bbox = this.bbox();

                    infoBeforeDrag = {
                        cursorX: e.clientX,
                        cursorY: e.clientY,
                        x: bbox.x,
                        y: bbox.y
                    };
            }
        });

        _this.object.on("mouseup mouseout", function(e) {
            onDraggable = false;
        });

        _this.object.mousemove(function(e) {
            if (onDraggable && infoBeforeDrag !== null) {
                switch(true) {
                    case this.type === "line":
                        var pathPosition = {
                            x1: (e.clientX - infoBeforeDrag.cursorX) + infoBeforeDrag.x1,
                            y1: (e.clientY - infoBeforeDrag.cursorY) + infoBeforeDrag.y1,
                            x2: (e.clientX - infoBeforeDrag.cursorX) + infoBeforeDrag.x2,
                            y2: (e.clientY - infoBeforeDrag.cursorY) + infoBeforeDrag.y2
                        };

                        this.plot(pathPosition.x1, pathPosition.y1, pathPosition.x2, pathPosition.y2);

                        if (typeof callback === "function") {
                            callback(pathPosition);
                        }

                        break;

                    default:
                        var newPosition = {
                            x: (e.clientX - infoBeforeDrag.cursorX) + infoBeforeDrag.x,
                            y: (e.clientY - infoBeforeDrag.cursorY) + infoBeforeDrag.y
                        };

                        this.move(
                            newPosition.x,
                            newPosition.y
                        );

                        if (typeof callback === "function") {
                            callback(newPosition);
                        }
                }
            }
        });
    };

    var activateGroupEvent = function() {
        var infoBeforeDrag = [];
        var onDraggable = false;

        _this.object.style("cursor", "move");

        _this.object.mousedown(function(e) {
            onDraggable = true;

            var childNodes = this.node.childNodes;

            childNodes.forEach(function(childNode, index) {
                var nodeObject = childNode.instance;

                infoBeforeDrag[index] = {
                    cursorX: e.clientX,
                    cursorY: e.clientY,
                    instance: nodeObject
                };

                if (nodeObject.type === "line") {
                    var nodeObjectPoints = nodeObject.array().value;

                    Object.assign(infoBeforeDrag[index], {
                        x1: nodeObjectPoints[0][0],
                        y1: nodeObjectPoints[0][1],
                        x2: nodeObjectPoints[1][0],
                        y2: nodeObjectPoints[1][1],
                    });
                } else {
                    var bbox = nodeObject.bbox();

                    Object.assign(infoBeforeDrag[index], {
                        x: bbox.x,
                        y: bbox.y,
                    });
                }
            });
        });

        _this.object.on("mouseup mouseout", function(e) {
            onDraggable = false;
        });

        _this.object.mousemove(function(e) {
            if (onDraggable && infoBeforeDrag !== null) {
                if (infoBeforeDrag.length > 0) {
                    var tempInstance;

                    infoBeforeDrag.forEach(function(infoBeforeDragRow) {
                        tempInstance = infoBeforeDragRow.instance;

                        if (tempInstance !== undefined) {
                            if (tempInstance.type === "line") {
                                var pathPosition = {
                                    x1: (e.clientX - infoBeforeDragRow.cursorX) + infoBeforeDragRow.x1,
                                    y1: (e.clientY - infoBeforeDragRow.cursorY) + infoBeforeDragRow.y1,
                                    x2: (e.clientX - infoBeforeDragRow.cursorX) + infoBeforeDragRow.x2,
                                    y2: (e.clientY - infoBeforeDragRow.cursorY) + infoBeforeDragRow.y2
                                };

                                tempInstance.plot(pathPosition.x1, pathPosition.y1, pathPosition.x2, pathPosition.y2);

                                if (typeof callback === "function") {
                                    callback(pathPosition);
                                }
                            } else {
                                var newPosition = {
                                    x: (e.clientX - infoBeforeDragRow.cursorX) + infoBeforeDragRow.x,
                                    y: (e.clientY - infoBeforeDragRow.cursorY) + infoBeforeDragRow.y
                                };

                                tempInstance.move(
                                    newPosition.x,
                                    newPosition.y
                                );

                                if (typeof callback === "function") {
                                    callback(newPosition);
                                }
                            }
                        }
                    });
                }
            }
        });
    };

    if (isGroupObject) {
        activateGroupEvent();
    } else {
        activateEvent();
    }
}